export class Constants {
	public static logging_endpoint = "https://logger.cluster.ceasy.de";
	public static logging_apiKey = "Gb9mnUBK3JaVAPHz7wcurRDV2tcZdc2H";
	public static logging_softwareName = "gufi";

	public static search_endpoint = "https://gufi.ceasy.de/api/v1/";
}
